import { useState, type FormEvent } from 'react';
import { copy } from '../copy/es';
import { api, textoDeError } from '../lib/api';

/** Mockup screen 6: an expired link offers a way out, never an error (E-2, VIII). */
export function VencidoPage() {
  const c = copy.portal.vencido;
  const [correo, setCorreo] = useState('');
  const [mensaje, setMensaje] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function pedir(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setEnviando(true);
    try {
      const r = await api<{ mensaje: string }>('/api/p/renovacion', {
        method: 'POST',
        body: JSON.stringify({ correo }),
      });
      setMensaje(r.mensaje);
    } catch (err) {
      setError(textoDeError(err));
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="stage">
      <section className="screen">
        <div className="card sm">
          <div className="p-head">
            <span className="logo-wrap">
              <img className="logo" src="/coninsa-logo.svg" alt="Coninsa" />
            </span>
            <div className="right">
              <div className="t">{copy.portal.titulo}</div>
              <div className="by">{copy.app.gobernadoPor.toUpperCase()}</div>
            </div>
          </div>
          <div className="p-body">
            {mensaje ? (
              <div className="ok-box" role="status">
                <b>{c.enviadoTitulo}</b> {mensaje}
              </div>
            ) : (
              <form onSubmit={pedir}>
                <div className="vencido">
                  <div className="ic">⏳</div>
                </div>
                <h2 style={{ textAlign: 'center' }}>{c.titulo}</h2>
                <p className="sub" style={{ textAlign: 'center' }}>
                  {c.subtitulo}
                </p>
                <div className="field" style={{ margin: '0 auto 16px' }}>
                  <label htmlFor="mail2">{c.correo}</label>
                  <input
                    id="mail2"
                    type="email"
                    autoComplete="email"
                    placeholder="gerencia@tercero.co"
                    value={correo}
                    onChange={(e) => setCorreo(e.target.value)}
                    required
                  />
                  <div className="hint">{c.pista}</div>
                </div>
                {error && (
                  <div className="err" role="alert">
                    {error}
                  </div>
                )}
                <div style={{ textAlign: 'center' }}>
                  <button className="cta" disabled={enviando}>
                    {c.pedir}
                  </button>
                </div>
              </form>
            )}
            <div className="expira">{c.pie}</div>
          </div>
        </div>
        <div className="foot">{copy.app.pie}</div>
      </section>
    </div>
  );
}
